import { log, LOG_LEVELS } from '@common/config/app_logger';
import { getBaseSuperProperties } from '@app/actions/mixpanel_properties';
import { AnalyticsProvider } from './AnalyticsProvider';
import { getHashedEmail } from './hashedEmail';

export class GTMProvider extends AnalyticsProvider {
  private excludedEvents: string[] = ['spent credits', 'achievement unlocked'];

  private eventNamesMap: Record<string, string> = {
    'chat attempt': 'live session attempt',
    'voice attempt': 'live session attempt',
    'vc attempt': 'live session attempt',
    'chat started': 'live session started',
    'voice started': 'live session started',
    'vc started': 'live session started'
  };

  public get name(): string { return 'GTM'; }

  public mapAndExtendProperties = (eventName: string, eventProperties?: Record<string, any>) => {
    if (this.excludedEvents.includes(eventName)) return eventProperties;
    const { user: { user } } = window.store.getState();

    const properties = eventProperties ? Object.keys(eventProperties).reduce((obj: any, key: string) => {
      obj[key] = Array.isArray(eventProperties[key])
        ? eventProperties[key].join(', ')
        : eventProperties[key];
      return obj;
    }, {}) : null;
    const userIdProperty = user?.id ? { 'user id': user.id } : {};

    return {
      ...properties,
      ...getBaseSuperProperties({ user, mixpanel: undefined }),
      ...userIdProperty
    };
  };

  public get initialized() { return true; }

  public init() {
  }

  public authorize() { }

  public reset() { }

  public trackEvent(eventName: string, eventProperties?: Record<string, any>) {
    if (this.excludedEvents.includes(eventName)) return;

    log(LOG_LEVELS.INFO, 'GTM', `track event: ${ eventName }`);

    const event = this.eventNamesMap[eventName] || eventName;
    const { user: { user } } = window.store.getState();

    // Chained on the hash promise: pushes stay FIFO and the event carries
    // a hashed 'email address' instead of the raw one (privacy requirement).
    getHashedEmail(user?.email).then((hashedEmail) => {
      const properties = {
        ...eventProperties,
        ...(hashedEmail ? { 'email address': hashedEmail } : {})
      };

      log(LOG_LEVELS.DEBUG, 'GTM', 'eventProperties', properties);

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event,
        ...properties
      });

      const clearedProps = Object.keys(properties).reduce((obj: any, key: string) => {
        obj[key] = undefined;
        return obj;
      }, {});

      window.dataLayer.push({
        ...clearedProps
      });
    });
  }

  public trackPageVisit(pageTitle: string): void {
    const eventName = 'page visit';
    const params = { url: window.location.href, 'page title': pageTitle };
    log(LOG_LEVELS.INFO, 'Optimove', `track page visit: ${ pageTitle }`);
    this.trackEvent(eventName, params);
  }
}
